import type { ShareData } from './types.tsx';

export const defaultShareContentState: ShareData = {
	users: [],
	comment: {
		format: 'plain_text' as const,
		value: '',
	},
};
